/**
 * Created by Ivan on 21.09.2026
 */

const StickersBookFlyIcon2 = function () {
    return Prefab.instantiate(bundles.merge.jsons.stickers2_fly_icon_prefab_json);
};
